import axios from 'axios';
// import sessionService from 'services/session'
import {SessionService} from 'services/SessionService'
import ses from "services/session";


let session = new SessionService();

let restApiSonOff = axios.create({
    baseURL: 'http://192.168.1.4:8081/zeroconf',
    headers: {
        'Content-Type': 'application/json',
    }
});

restApiSonOff.interceptors.request.use(function (config) {
    return config;
}, function (error) {
    return Promise.reject(error);
});

restApiSonOff.interceptors.response.use(function (response) {
        return response;
    }, function (error) {
        if ((error.response.status === 401 || error.response.status === 403) && !window.location.href.includes('login')) {
            return session.handleErrorResponse(error);
        }else if((error.response.status === 401 || error.response.status === 403) && window.location.href.includes('login')){
            return session.handleLoginErrorResponse(error)
        }else if(error.response.status === 409 && error.response.data.error_description.includes('Morate da prihvatite uslove')){
            return session.handleAcceptTermsErrorResponse(error)
        } else {
            return Promise.reject(error.response);
        }
    }
);


export default restApiSonOff



// WEBPACK FOOTER //
// ./src/http-common-sonoff.js